var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "radio-container" }, [
    _c("input", {
      ref: "radioInput",
      attrs: {
        type: "radio",
        name: _vm.name,
        id: _vm.id,
        required: _vm.required,
        disabled: _vm.disabled
      },
      domProps: { value: _vm.value, checked: _vm.value === _vm.selectedValue },
      on: { change: _vm.updateValue }
    }),
    _vm._v(" "),
    _vm.label
      ? _c(
          "label",
          { staticClass: "font-smoothing", attrs: { for: _vm.id } },
          [
            _vm.useSpan
              ? _c("span", [_vm._v(_vm._s(_vm.label))])
              : [_vm._v(_vm._s(_vm.label))]
          ],
          2
        )
      : _vm.labelAsSlot
      ? _c(
          "label",
          { staticClass: "font-smoothing", attrs: { for: _vm.id } },
          [_vm._t("label")],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }